export default {
  // Endpoints
  loginEndpointStepOne: '/seguranca/login-step-one',
  loginEndpointStepTwo: '/seguranca/login-step-two',
  loginGoogleEndpoint: '/seguranca/login-google',
  getClientGoogleEndpoint: '/seguranca/client-google',
  alterarSenhaEndpoint: '/seguranca/trocar-senha',
  forgotPasswordEndpoint: '/seguranca/esqueci-senha',
  confirmAccessEndpoint: '/seguranca/confirmar-acesso',
  registerEndpoint: '',
  refreshEndpoint: '',
  logoutEndpoint: '',

  tokenType: 'Bearer',

  // Value of this property will be used as key to store JWT token in storage
  storageTokenKeyName: 'accessToken',
  storageRefreshTokenKeyName: '',
}
